module.exports = __webpack_public_path__ + "static/media/astonished-emoji-svgrepo-com (1).21cb8e55.svg";